import { MapPin } from "lucide-react";
import mapImg from "@/assets/images/newMapColorstone.webp";

// Southern California service-area map (Greater L.A., Orange & San Bernardino
// counties shaded green). Shows the full image (no cropping), full-width.
export default function SoCalMap({
  className = "",
  countiesClassName = "bottom-3 left-3",
  countiesLabel = "Counties we serve",
  countiesBare = false,
  overlays = true,
}) {
  return (
    <div className={`relative w-full overflow-hidden bg-[#0F172A] ${className}`}>
      <img
        src={mapImg}
        alt="ColorStone service area across Southern California — Greater Los Angeles, Orange & San Bernardino counties"
        loading="lazy"
        className="block h-auto w-full"
      />

      {overlays && (
        <>
          {countiesBare ? (
            <div
              className={`pointer-events-none absolute z-10 flex items-center gap-1.5 text-xs font-bold text-white [text-shadow:_0_1px_2px_rgba(0,0,0,0.9),_0_0_5px_rgba(0,0,0,0.7)] ${countiesClassName}`}
            >
              <span className="h-3 w-3 rounded-sm border-2 border-[#22C55E] bg-[#22C55E]/60" />
              {countiesLabel}
            </div>
          ) : (
            <div
              className={`pointer-events-none absolute z-10 flex items-center gap-2 rounded-lg bg-white/95 px-3 py-2 text-xs font-semibold text-[#0F172A] shadow ${countiesClassName}`}
            >
              <span className="h-3 w-3 rounded-sm border-2 border-[#22C55E] bg-[#22C55E]/40" />
              {countiesLabel}
            </div>
          )}
          <div className="pointer-events-none absolute right-3 top-3 z-10 flex items-center gap-1.5 rounded-full bg-[#2563EB] px-3 py-1.5 text-xs font-bold text-white shadow">
            <MapPin className="h-3.5 w-3.5" /> Southern California
          </div>
        </>
      )}
    </div>
  );
}
